module.exports = __webpack_public_path__ + "static/media/prick_HMPG_survey_image_1400.93fc7d50.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/prick_HMPG_survey_image_1400.jpg
// module id = 359
// module chunks = 0